import { Link } from "react-router-dom";
import { Clock, ChevronRight, ArrowRight } from "lucide-react";
import { BLOG_POSTS } from "@/pages/blog/posts";
import { getCover } from "@/pages/blog/covers";

export default function LatestPostsSection() {
  const latest = [...BLOG_POSTS]
    .sort((a, b) => new Date(b.date) - new Date(a.date))
    .slice(0, 3);

  return (
    <section className="py-20 md:py-28 bg-[#f0ebe1]" data-testid="latest-posts-section">
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10">
          <div>
            <p className="text-[11px] uppercase tracking-[0.28em] text-[#bc6c25] font-bold">Del blog</p>
            <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl mt-2 leading-[1.1] text-[#1a2421]">
              Lo más nuevo, en <em className="text-[#bc6c25]">tu lectura</em>
            </h2>
          </div>
          <Link
            to="/blog"
            data-testid="see-all-posts-btn"
            className="inline-flex items-center gap-2 text-sm text-[#1a2421] hover:text-[#bc6c25] font-semibold tracking-wide self-start md:self-end"
          >
            Ver todos los artículos <ArrowRight className="w-4 h-4" />
          </Link>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-7">
          {latest.map((post) => {
            const cover = getCover(post.category);
            return (
              <Link
                key={post.slug}
                to={`/blog/${post.slug}`}
                data-testid={`latest-card-${post.slug}`}
                className="group bg-white rounded-3xl overflow-hidden border border-[#2c4a3b]/8 hover:border-[#bc6c25]/40 hover:shadow-[0_20px_40px_-15px_rgba(26,36,33,0.18)] hover:-translate-y-1 transition-all duration-500"
              >
                <div
                  className="relative aspect-[4/3] overflow-hidden"
                  style={{ background: cover.bg }}
                >
                  <img
                    src={`/blog-images/${post.slug}.jpg`}
                    alt={post.title}
                    loading="lazy"
                    className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                    onError={(e) => { e.currentTarget.style.display = "none"; }}
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-black/10 to-transparent" />
                  <div className="absolute top-4 left-4 text-[10px] uppercase tracking-[0.22em] font-bold text-white drop-shadow">
                    {post.category}
                  </div>
                </div>
                <div className="p-6">
                  <h3 className="font-serif text-xl leading-tight text-[#1a2421] group-hover:text-[#bc6c25] transition-colors">
                    {post.title}
                  </h3>
                  <p className="mt-3 text-sm text-[#5c6b61] leading-relaxed line-clamp-2">{post.excerpt}</p>
                  <div className="mt-4 flex items-center justify-between text-xs text-[#5c6b61]">
                    <span className="inline-flex items-center gap-1.5">
                      <Clock className="w-3.5 h-3.5" /> {post.minutes} min
                    </span>
                    <span className="inline-flex items-center gap-1 text-[#bc6c25] font-semibold uppercase tracking-[0.18em]">
                      Leer <ChevronRight className="w-3.5 h-3.5" />
                    </span>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}
